import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ff6b59b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "map",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = {
  class: "space-main",
  id: "spaceMain"
}
const _hoisted_3 = ["id", "onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  style: {"font-size":"12px"}
}
const _hoisted_7 = { class: "map-toolbar" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "text-hidden" }
const _hoisted_10 = { class: "text-hidden" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { style: {"width":"100%","height":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_canvas_box = _resolveComponent("canvas-box")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_space_search = _resolveComponent("space-search")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.mapType == 1)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.mapData.spaceList, (area, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "space-box",
              style: _normalizeStyle({
            width: area.width + 'px',
            height: area.height + 'px',
            top: area.top + 'px',
            left: area.left + 'px',
            transform: 'rotate(' + area.rotate + ')',
            borderRadius:
              area.borderRadius[0] +
              'px' +
              ' ' +
              area.borderRadius[1] +
              'px' +
              ' ' +
              area.borderRadius[2] +
              'px' +
              ' ' +
              area.borderRadius[3] +
              'px',
          }),
              key: 'map' + index
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["space", [
              area.canClick ? '' : 'click-disable',
              _ctx.selectArea.spaceId === area.spaceId
                ? area.disabled
                  ? 'select-disable'
                  : 'select'
                : '',
              _ctx.isSetSpace ? 'use-select' : '',
              area.disabled ? 'space-disable-box' : 'space-box-bg',
            ]]),
                id: 'space' + area.id,
                onClick: _withModifiers(($event: any) => (_ctx.checkSpace(area)), ["stop"]),
                style: _normalizeStyle({
              backgroundColor: area.backgroundColor ? area.backgroundColor : '',
            })
              }, [
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(["device", 
                _ctx.selectArea.spaceId === area.spaceId ? 'select-device' : ''
              ])
                }, [
                  (_ctx.selectArea.spaceId !== area.spaceId && area.icon)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: area.icon
                      }, null, 8, _hoisted_4))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: area.selectIcon,
                        class: "select-icon",
                        alt: ""
                      }, null, 8, _hoisted_5)),
                  (area.localName)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        (
                    (area.height > 80 &&
                      area.localName.length * 12 < area.width) ||
                    _ctx.selectArea.spaceId === area.spaceId
                  )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(area.localName), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2), [
                  [_vShow, 
                area.width * _ctx.displacement.scale > 24 &&
                area.height * _ctx.displacement.scale > 24
              ]
                ])
              ], 14, _hoisted_3)
            ], 4))
          }), 128))
        : (_openBlock(), _createBlock(_component_canvas_box, {
            key: 1,
            class: "canvasBox",
            ref: "canvasRef",
            mapData: _ctx.mapData,
            onCheckSpace: _ctx.checkSpace
          }, null, 8, ["mapData", "onCheckSpace"]))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("img", {
        src: _ctx.parseImgUrl('map-icon', 'icon-search-big.svg'),
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goSearch && _ctx.goSearch(...args)), ["stop"])),
        class: "icon-search",
        alt: ""
      }, null, 8, _hoisted_8),
      _createElementVNode("div", {
        class: "toolbar-item",
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.checkFloor && _ctx.checkFloor(...args)), ["stop"]))
      }, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.floorItem.localName), 1)
      ]),
      _createElementVNode("div", {
        class: "toolbar-item",
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.checkBuilding && _ctx.checkBuilding(...args)), ["stop"]))
      }, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.buildingItem.localName), 1)
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.showBuilding,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showBuilding) = $event)),
      teleport: "body",
      class: "buiding-box",
      style: {"width":"40%","height":"100%","padding":"20px"},
      position: "right"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buildingData, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["buiding-item", _ctx.buildingItem.buildingId === item.id ? 'active' : '']),
            key: item.id,
            onClick: _withModifiers(($event: any) => (_ctx.comfirmBuilding(item)), ["stop"])
          }, _toDisplayString(item.localName), 11, _hoisted_11))
        }), 128))
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showFloor,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showFloor) = $event)),
      teleport: "body",
      class: "buiding-box",
      style: {"width":"40%","height":"100%","padding":"20px"},
      position: "right"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.floorData, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["buiding-item", _ctx.floorItem.id === item.id ? 'active' : '']),
            key: item.id,
            onClick: _withModifiers(($event: any) => (_ctx.comfirmFloor(item)), ["stop"])
          }, _toDisplayString(item.localName), 11, _hoisted_12))
        }), 128))
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showSearch,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showSearch) = $event)),
      teleport: "body",
      class: "buiding-box",
      style: {"width":"100%","height":"100%"},
      position: "right"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_space_search, { onCloseSearch: _ctx.closeSearch }, null, 8, ["onCloseSearch"])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}